window.TimePickerDefaultSettings = {
  format: 'hh:mm A',
  time: true,
  shortTime: true,
  date: false,
};

(function () {
  const outingEventsRoundTeamsApp = function () {
    let suppressRemote = false;

    const processSelectResults = (labelMethod, data) => {
      return {
        results: data.data.map(function (elem) {
          return { id: elem.id, text: elem[labelMethod] };
        }),
      };
    };

    const bindCourseSelect = () => {
      const $course = $('#course_id');
      if (!$course.length) return;

      if ($course.data('select2')) $course.select2('destroy');

      $course.select2({
        ajax: {
          url: '/courses?for_league_settings=true&_type=query',
          delay: 400,
          dataType: 'json',
          processResults: function (data) {
            return processSelectResults('name', data);
          },
        },
      });
    };

    const loadSides = (courseId) => {
      const url = $('#rounds-teams-form').data('sides-url');
      if (!url || !courseId) return;

      $.ajax({
        url,
        data: { course_id: courseId },
        dataType: 'script',
      });
    };

    const loadTees = (sideId) => {
      const url = $('#rounds-teams-form').data('tees-url');
      if (!url) return;

      $.ajax({
        url,
        data: { side_id: sideId },
        dataType: 'script',
      });
    };

    const bindDateInputs = () => {
      $.extend($.fn.pickadate.defaults, { format: 'mm/dd/yyyy', clear: false });
      $('#round_date').mask('00/00/0000').pickadate();
      $("[name*='times[']").bootstrapMaterialDatePicker(
        window.TimePickerDefaultSettings
      );
    };

    const bindSelectTees = () => {
      const men_tee_id = $('#men_tee_id').val();
      const women_tee_id = $('#women_tee_id').val();
      const links = ['.auto-configure-shotgun', '.auto-configure-tee-times'];
      for (var i = 0; i < links.length; i++) {
        const $link = $(links[i]);
        if (!$link.length || !$link.attr('data-href')) continue;

        const url = `${$link.attr(
          'data-href'
        )}&men_tee_id=${men_tee_id}&women_tee_id=${women_tee_id}`;
        $link.attr('href', url);
      }
    };

    const initOutingRoundTeamsForm = () => {
      if (
        !$('body').hasClass('controller-outings-rounds_teams') &&
        !$('body').hasClass('controller-outings-round_settings')
      )
        return;

      suppressRemote = true;
      bindCourseSelect();
      bindDateInputs();

      if ($('#course_id').val()) {
        $('.side-options').removeClass('d-none');
        $('.side-options .select2').select2();
      }

      bindSelectTees();
      suppressRemote = false;
    };

    $(document).on('change', '#course_id', function () {
      if (suppressRemote) return;

      const courseId = $(this).val();
      if (!courseId) {
        $('.side-options').addClass('d-none');
        return;
      }

      loadSides(courseId);
    });

    $(document).on('change', '#side_id', function () {
      if (suppressRemote) return;

      loadTees($(this).val());
    });

    $(document).on('change', '#men_tee_id, #women_tee_id', bindSelectTees);

    $(document).on('turbolinks:load', initOutingRoundTeamsForm);

    window.initOutingRoundTeamsForm = initOutingRoundTeamsForm;
  };

  if (typeof window !== 'undefined') {
    window.outingEventsRoundTeamsApp = outingEventsRoundTeamsApp();
  }
})();
